import {
  ApplicationRef,
  Component,
  ElementRef,
  Input,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  Renderer2,
  OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cona-tooltip',
  templateUrl: './cona-tooltip.component.html',
  styleUrls: ['./cona-tooltip.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class ConaTooltipComponent implements OnDestroy {
  @Input() text: string = '';
  @Input() position: 'top' | 'bottom' | 'left' | 'right' | 'left-center' | 'top-right' | 'top-left' = 'top';
  @Input() bgColor: 'white' | 'red' | 'black' = 'black';

  @ViewChild('toolTipContainerRef', { static: true })
  toolTipContainerRef!: ElementRef<HTMLDivElement>;

  @ViewChild('tooltipTemplate', { static: true })
  tooltipTemplateRef!: TemplateRef<any>;

  private tooltipViewRef: any;
  private tooltipEl!: HTMLElement;

  constructor(private appRef: ApplicationRef, private renderer: Renderer2) {}

  showTooltip() {
    if (this.tooltipViewRef) return; // prevent duplicates

    // Create view from template
    this.tooltipViewRef = this.tooltipTemplateRef.createEmbeddedView({});
    this.appRef.attachView(this.tooltipViewRef);
    this.tooltipEl = this.tooltipViewRef.rootNodes[0] as HTMLElement;

    // Apply temporary styles to measure
    this.renderer.setStyle(this.tooltipEl, 'position', 'absolute');
    this.renderer.setStyle(this.tooltipEl, 'visibility', 'hidden');
    this.renderer.setStyle(this.tooltipEl, 'pointer-events', 'none');

    // Append to body
    document.body.appendChild(this.tooltipEl);

    // Wait for DOM to apply styles and render the element
    requestAnimationFrame(() => {
      const viewportWidth = window.innerWidth;
      const containerRect = this.toolTipContainerRef.nativeElement.getBoundingClientRect();
      const tooltipRect = this.tooltipEl.getBoundingClientRect();

      let top = 0;
      let left = 0;

      switch (this.position) {
        case 'left-center':
          top = containerRect.top + containerRect.height / 2 - tooltipRect.height / 2;
          left = containerRect.left - tooltipRect.width - 8;
          this.renderer.setStyle(this.tooltipEl, 'left', `${left}px`);
          break;
        case 'top-right':
          top = containerRect.top - tooltipRect.height - 8;
          left = viewportWidth - containerRect.x - (containerRect.width / 2 + 20);
          this.renderer.setStyle(this.tooltipEl, 'right', `${left}px`);
          break;
        case 'top-left':
          top = containerRect.top - tooltipRect.height - 8;
          left = viewportWidth - (viewportWidth - containerRect.x) + (containerRect.width / 2 - 20);
          this.renderer.setStyle(this.tooltipEl, 'left', `${left}px`);
          break;
      }

      // Apply final styles
      this.renderer.setStyle(this.tooltipEl, 'top', `${top}px`);
      this.renderer.setStyle(this.tooltipEl, 'visibility', 'visible');
      this.renderer.setStyle(this.tooltipEl, 'pointer-events', 'auto');
    });
  }

  hideTooltip() {
    if (this.tooltipViewRef) {
      this.appRef.detachView(this.tooltipViewRef);
      this.tooltipViewRef.destroy();
      this.tooltipViewRef = null;
    }
    if (this.tooltipEl && this.tooltipEl.parentElement) {
      this.tooltipEl.parentElement.removeChild(this.tooltipEl);
    }
  }

  ngOnDestroy(): void {
    this.hideTooltip();
  }
}
